<template>
  <div>
    <v-row class="ma-0 pa-0">
      <v-col v-for="(data,index) of subLinkData" :key="index" class="mb-4 px-4 width-100 item-inline py-0" ref="cardOuter" :cols="data.spCols" :sm="data.cols">
        <v-card tile elevation="3" class="link-card" @click="outWebJunp(data)" :color="data.color">
          <v-img :src="data.img" height="100%" cover>
            <div :to="!data.isOut ? data.href : ''" class="link-card-inner">
              <div class="margin-auto">
                <div class="card-text-area" :style="'color:' + data.fontColor">
                  <div class="card-title font-bold font-large-xs line-height-m">{{data.title}}</div>
                  <div class="card-sub-title font-medium-xl">{{data.subTitle}}</div>
                </div>
                <v-icon v-if="data.title" size="18px" :color="data.fontColor" style="padding:8px">mdi-arrow-right-drop-circle</v-icon>
              </div>
            </div>
          </v-img>
        </v-card>

      </v-col>
    </v-row>

  </div>
</template>

<script>
export default {
  name: 'link-card',
  prop: {
    data: {}
  },
  data: function () {
    return {
    }
  },
  methods: {
    init: function () {
      const self = this
      console.dir(this.$refs.cardOuter)
      this.$refs.cardOuter.map((v, i) => {
        v.$el.style.height = (v.clientWidth - 32) * (self.subLinkData[i].height / self.subLinkData[i].width) + 'px'
      })
    },
    outWebJunp: function (data) {
      if (data.isOut) {
        if (!window.open(data.href)) {
          window.location.href = data.href
        }
      } else {
        this.$router.push(data.href)
      }
    }
  },
  mounted: function () {
    const self = this
    window.addEventListener('resize', this.init)
    setTimeout(function () {
      self.init()
    }, 500)
  }
}
</script>

<style scoped>

.font-color-bl{
  color: #2d2d2d;
}

.font-color-wh{
  color: #fff;
}

.text-vertical-middle{
  vertical-align: sub;
}

.link-card {
  height: 100%;
  overflow: hidden;
}

.link-card-inner{
  display: flex;
  height: 100%;
  position: relative;
}

.card-text-area {
  display: inline-block;
  vertical-align: middle;
}

.background-icon {
  position: absolute;
  top: 10px;
  left: -60px;
  opacity: 0.16;
  overflow: hidden;
}
.shadow-text{
  text-shadow: #000 1px 1px 3px;
}

</style>
